

jQuery( document ).ready(function() {	
  console.log("add to cart got");
 
  $( "#my_add_to_cart_btn" ).on( "click", function() {
    
  	console.log("add to cart");
  });
  const defaults = {    
    addToCart: '.js-ajax-add-to-cart', // classname 
    cartCounter: '.js-ajax-cart-counter', 
  }; 
  const addToCart = document.querySelectorAll(defaults.addToCart);
  const cartCounter = document.querySelectorAll(defaults.addToCart);



  for (let i = 0; i < addToCart.length; i++) {
    addToCart[i].addEventListener('click', function(event) {
      event.preventDefault();
      // const formID = this.parentNode.getAttribute('id');
      const formID = $(this).parents("form").attr('id');
      console.log(formID);
      addProductToCart(formID);

    });
  }


  function addProductToCart(formID) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: $('#' + formID)
      .serialize(),
      success: addToCartOk,
      error: addToCartFail,
    });
  }

  function addToCartOk(product) {   
    console.log("addToCartOk");   
    fetchCart();
    /*var value = parseInt($(".js-ajax-cart-counter").text());   
      value = value + 1;
      $(".js-ajax-cart-counter").parent(".site-header__cart-count").removeClass("hide");
      $(".js-ajax-cart-counter").text(value);*/    

}    


  function addToCartFail() {
    console.log("addToCartFail");
  }

  function fetchCart() {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {       
        console.log("cart :: "+JSON.stringify(cart));
        $(".js-ajax-cart-counter").parent(".site-header__cart-count").removeClass("hide");
        $(".js-ajax-cart-counter").text(cart.item_count);


       
        cart.items.forEach(function(item, index) {         
          if(index == 0){
          $(".cart-popup-item__title").html(item.product_title);
          $(".cart-popup-item__image-wrapper").html("<img src='"+item.image+"' class='cart-popup-item__image'>").removeClass("hide");   
          $(".cart-popup-item__quantity .qty").html(item.quantity);  
          }
        });
        setTimeout(function(){          
          $(".cart-popup__cta-link span").html(cart.item_count);
          $(".cart-popup-wrapper").fadeIn("fast").removeClass('cart-popup-wrapper--hidden');
        }, 50);
        /*
        setTimeout(function(){      
          $(".cart-popup-wrapper").fadeOut("slow").addClass('cart-popup-wrapper--hidden');
        }, 7000);*/
      },
    });
  }

  jQuery("body").on("click",".cart-popup__close", function(){
    $(".cart-popup-wrapper").fadeOut("slow").addClass('cart-popup-wrapper--hidden');
  });

});
/*
if (window.addEventListener)
  window.addEventListener("load", downloadJSAtOnload, false);
else if (window.attachEvent)
  window.attachEvent("onload", downloadJSAtOnload);
else window.onload = downloadJSAtOnload;*/
